export default __webpack_public_path__ + "static/media/Pc9.43ef9c75.jpg";